import * as Validation from "Sauce/Validation";
import { PhoneNumber } from "Sauce/Validation/PhoneNumber";
import { handle_null, clamp } from "Util";
import * as mathjs from "mathjs";
import * as _ from "lodash";

export class RoundingInteger extends Validation.ValueProcessorFactory<number> {
    private fac: Validation.ValueProcessorFactory<number>;
    constructor(public min?: number, public max?: number) {
        super();
        this.fac = new Validation.ValueProcessorFactory<number>(
            (formatted: string) => clamp(Math.round(mathjs.eval(formatted)), min, max),
            (val: number) => !_.isFinite(val) ? "Not a finite number" : "",
            (val: number) => val.toString()
        )
    }
    make() {
        return this.fac.make();
    }
}


export class CheckboxValue extends Validation.ValueProcessorFactory<boolean> {
    private fac: Validation.ValueProcessorFactory<boolean>;
    constructor() {
        super((formatted: string) => formatted ? true : false,);
    }
}

export class Real extends Validation.ValueProcessorFactory<number> {
    private fac: Validation.ValueProcessorFactory<number>;
    constructor(public precision?: number, public min?: number, public max?: number) {
        super();
        this.fac = new Validation.ValueProcessorFactory<number>(
            (formatted: string) => clamp(mathjs.eval(formatted), min, max),
            (val: number) => !_.isFinite(val) ? "Not a finite number" : "",
            (val: number, raw: string) => _.isFinite(val) ? val.toPrecision(precision) : raw
        )
    }
    make() {
        return this.fac.make();
    }
}

export class RealExpression extends Validation.ValueProcessorFactory<number> {
    private fac: Validation.ValueProcessorFactory<number>;
    constructor(public precision?: number, public min?: number, public max?: number) {
        super();
        this.fac = new Validation.ValueProcessorFactory<number>(
            (formatted: string) => clamp(mathjs.eval(formatted), min, max),
            (val: number) => !_.isFinite(val) ? "Not a finite number" : "",
            (_, raw) => raw
        )
    }
    make() {
        return this.fac.make();
    }
}
export const AnyReal = new Real().make();
export const AnyRealExpression = new RealExpression().make();

export class Label extends Validation.ValueProcessorFactory<string> {
    private fac: Validation.ValueProcessorFactory<string>;
    constructor(protected process?: (preformatted: string) => string,
				protected postvalidate?: (processed: string | null, preformatted?: string) => string,
				protected format?: (processed: string | null, preformatted?: string) => string,
				protected prevalidate?: (preformatted: string) => string,
                protected preformat?: (raw: string) => string) {
        super();
        this.fac = new Validation.ValueProcessorFactory<string>(this.process, this.postvalidate, this.format, this.prevalidate, this.preformat)
    }
    make() {
        return this.fac.make();
    }
}


// WEBPACK FOOTER //
// ./src/code/Sauce/Validation/Basic.ts